import { ProductTable } from "features/product/types/subproductTable";
import { useSelector } from "services/redux/rootReducer";

const useCurrentTableState = (): ProductTable => {
    const { tables, shownTableId } = useSelector((state) => state.subProducts);

    return {
        ...(tables[shownTableId] ?? {}),
    };
};

export default useCurrentTableState;
